import axiosInstance from "./axiosInstance";
import APIEndpoint from "./endpoint";

export const getRoleList = (page) => {
  const res = axiosInstance.get("https://dummyjson.com/users");
  return res;
};

export const searchUserManagement = (searchValues, pageValues) => {
  const api = APIEndpoint.SEARCH_USER_MANAGEMENT_API;
 
  const payload = {
    requestObject: {
      username: searchValues.username,
      fullName: searchValues.fullName,
      estateId: searchValues.estateId,
      lineOfWorkId: searchValues.lineOfWorkId,
    },
    pageValue: {
      page: pageValues.page,
      pageSize: pageValues.pageSize,
      sortBy: pageValues.sortBy,
      sortDirection: pageValues.sortDirection,
    },
  };

  const res = axiosInstance.post(api, payload);
  return res;
};
export const searchUserLoginReport = (searchValues, pageValues) => {
 // const api = APIEndpoint.SEARCH_USER_MANAGEMENT_API;
  const api = APIEndpoint.SEARCH_USER_REPORT_LOGIN_API;
  const payload = {
    requestObject: {
      username: searchValues.username,
      fullName: searchValues.fullName,
      estateId: searchValues.estateId,
      lineOfWorkId: searchValues.lineOfWorkId,
    },
    pageValue: {
      page: pageValues.page,
      pageSize: pageValues.pageSize,
      sortBy: pageValues.sortBy,
      sortDirection: pageValues.sortDirection,
    },
  };

  const res = axiosInstance.post(api, payload);
  return res;
};


export const createUser = (request) => {
  const api = APIEndpoint.CREATE_USER_API;
  const payload = {
    requestObject: {
      username: request.username,
      firstname: request.firstname,
      lastname: request.lastname,
      roleId: request.roleId,
      email: request.email,
      description: request?.description,
      accountStatus: request?.accountStatus,
      estateId: request.estateId,
      lineOfWorkId: request.lineOfWorkId,
    },
  };

  const res = axiosInstance.post(api, payload);
  return res;
};

export const deleteUser = (id) => {
  const uid = parseInt(id);
  const api = APIEndpoint.DELETE_USER_API + `?userId=`;
  const res = axiosInstance.delete(api + parseInt(uid));
  return res;
};

export const searchRoleManagement = async (searchValues, pageValues) => {
  const api = APIEndpoint.SEARCH_ROLE_MANAGEMENT_API;
  const payload = {
    requestObject: {
      roleName: searchValues?.roleName || "",
      permissionId: searchValues?.permissionId || "",
    },
    pageValue: {
      page: pageValues?.page,
      pageSize: pageValues?.pageSize,
      sortBy: pageValues?.sortBy,
      sortDirection: pageValues?.sortDirection,
    },
  };
  const res = await axiosInstance.post(api, payload);
  return res;
};

export const getRoleId = async (id) => {
  const api = APIEndpoint.GET_ROLE_MANAGEMENT_API + `/${id}`;
  const res = await axiosInstance.get(api);
  return res;
};

export const deleteRoleUser = async (id) => {
  const api =
    APIEndpoint.DELETE_ROLE_MANAGEMENT_API + `/delete?authorizationId=${id}`;
  const res = await axiosInstance.delete(api);
  return res;
};

export const updateRoleUser = async (payload) => {
  const api = APIEndpoint.UPDATE_ROLE_MANAGEMENT_API;
  const res = await axiosInstance.put(api, payload);
  return res;
};

export const updateRoleUserStatus = async (payload) => {
  const api = APIEndpoint.UPDATE_ROLE_USER_STATUS_API;
  const res = await axiosInstance.put(api, payload);
  return res;
};

export const deleteSummaryVisitor = async (id) => {
  const api =
    APIEndpoint.DELETE_CURRENT_CUSTOMER_SUMMARY_VISITOR_API +
    `/?summaryId=${id}`;
  const res = await axiosInstance.delete(api);
  return res;
};

// Staff
export const getPosition = async () => {
  const url = `${APIEndpoint.GET_POSITION_API}`;

  const res = await axiosInstance.get(url);
  return res;
};

export const searchStaffManagement = (searchValues, pageValues) => {
  const api = APIEndpoint.SEARCH_STAFF_MANAGEMENT_API;
  const payload = {
    requestObject: {
      fullName: searchValues.fullName || "",
      prefix: searchValues.prefix || "",
      staffName: searchValues.staffName || "",
      staffLastname: searchValues.staffLastname || "",
      positionUniqueId: searchValues.positionUniqueId || "",
    },
    pageValue: {
      page: pageValues.page,
      pageSize: pageValues.pageSize,
      sortBy: pageValues.sortBy,
      sortDirection: pageValues.sortDirection,
    },
  };

  const res = axiosInstance.post(api, payload);
  return res;
};

export const createStaff = (request) => {
  const api = APIEndpoint.CREATE_STAFF_MANAGEMENT_API;
  const payload = {
    prefix: request.prefix,
    staffName: request.staffName,
    staffLastname: request.staffLastname,
    positionUniqueId: request.positionUniqueId,
  };

  const res = axiosInstance.post(api, JSON.stringify(payload));
  return res;
};

export const updateStaff = async (id, request) => {
  const url = `${APIEndpoint.UPDATE_STAFF_MANAGEMENT_API}` + `/${id}`;
  const payload = {
    prefix: request.prefix,
    staffName: request.staffName,
    staffLastname: request.staffLastname,
    positionUniqueId: request.positionUniqueId,
  };

  const res = await axiosInstance.put(url, JSON.stringify(payload));
  return res;
};

export const deleteStaff = (id) => {
  const api = APIEndpoint.DELETE_STAFF_MANAGEMENT_API + `/`;
  const res = axiosInstance.delete(api + id);
  return res;
};
